import EN from './en.json';
import FR from './fr.json';
import { TranslationObject } from '@ngx-translate/core';

const I18N_DEFAULT_LANG: string = 'en';
const I18N_FRENCH_LANG: string = 'fr';
const I18N_ENGLISH_LANG: string = 'en';

const I18N_LANG: Record<string, TranslationObject> = {
  en: EN as TranslationObject,
  fr: FR as TranslationObject
};

export { I18N_LANG, I18N_DEFAULT_LANG, I18N_FRENCH_LANG, I18N_ENGLISH_LANG };
